import { useEffect, useRef } from "react";

const EVENT = "tadpole:open-organization-settings";

/**
 * Opens Organization Settings on one of its tabs (by its name, such as
 * "Billing") from a page that doesn't hold the dialog: the profile menu
 * opens it and the dialog switches to the tab.
 */
export function openOrganizationSettings(tab: string) {
  window.dispatchEvent(new CustomEvent<string>(EVENT, { detail: tab }));
}

/** Calls onOpen with the tab each time Organization Settings is asked for. */
export function useOpenOrganizationSettings(onOpen: (tab: string) => void) {
  const latest = useRef(onOpen);
  latest.current = onOpen;
  useEffect(() => {
    const listener = (event: Event) =>
      latest.current((event as CustomEvent<string>).detail);
    window.addEventListener(EVENT, listener);
    return () => window.removeEventListener(EVENT, listener);
  }, []);
}
